import React, { useState,useEffect } from 'react';

import CybersourceCheckout from './CybersourceCheckouts'; // Assuming it's in the same directory
import './StudentNumberForm.css'; // Custom styles
import axios from 'axios';

const mockDatabase = [
  {
    User_ID: "240300010",
    ReviewStatus: "Pending",
    IndexID: 27,
    FirstName: "GRACE",
    LastName: "KAPALAYI",
    Email: "gkapalayi@unilus.ac.zm",
    CreationDate: "2024-03-26T22:00:00.000Z",
    Phone: null,
    Status: "Pending",
    CourseName: "Digital Marketing",
    Cost: 3500,
    StartDate: "2024-04-19"
  },
  // Add more student objects as needed
];




const StudentPayment = () => {
  const [step, setStep] = useState(1);
  const [studentNumber, setStudentNumber] = useState('');
  const [student, setStudent] = useState(null);
  const [amount, setAmount] = useState('');
  const [currency, setCurrency] = useState('USD');
  const [students, setStudents] = useState([]);


  useEffect(() => {
    async function getCourses() {
      try {
        const response = await axios.get(process.env.REACT_APP_BASEURL + '/api/application/all');
        if (response) {
          console.log('students2', response);
          setStudents(response.data);
        } else {
          console.log('pull fail');
        }
      } catch (e) {
        console.log('catch error', e);
      }
    }
    getCourses();
  }, []);

  const handleLookup = () => {
    const foundStudent = students?.find(
      (student) => student.User_ID === studentNumber
    );
    setStudent(foundStudent || null);
    if (foundStudent) {
      setStep(2); // Move to amount and currency step
    } else {
      alert('Student not found');
    }
  };

  const handleProceed = () => {
    if (student && amount) {
      setStep(3); // Move to summary step
    } else {
      alert('Please fill in all fields');
    }
  };

  return (
    <div className="containerSec">
      <h1>UNILUS Payment Portal</h1>
      <h3>Accepting Payments via Visa</h3>

      {step === 1 && (
        <div className="lookup-form">
          <input
            type="text"
            placeholder="Enter Student Number"
            value={studentNumber}
            onChange={(e) => setStudentNumber(e.target.value)}
          />
          <button onClick={handleLookup}>Verify details</button>
        </div>
      )}

      {step === 2 && student && (
        <div className="amount-currency-form">
          <h2>Welcome, {student.FirstName} {student.LastName}</h2>
          <input
            type="number"
            placeholder="Enter Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
          <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
            <option value="USD">USD</option>
            <option value="ZMW">ZMW</option>
          </select>
          <button onClick={handleProceed}>Proceed to Summary</button>
          <button onClick={() => setStep(1)}>Go Back</button>
        </div>
      )}

      {step === 3 && (
        <div className="summary-details">
          <h2>Payment Summary</h2>
          <p><strong>Student Number:</strong> {student.User_ID}</p>
          <p><strong>Name:</strong> {student.FirstName} {student.LastName}</p>
          {/* <p><strong>Course:</strong> {student.CourseName}</p> */}
          <p><strong>Amount:</strong> {amount} {currency}</p>
          <button onClick={() => setStep(2)}>Go Back</button>
          <CybersourceCheckout 
            student={student} 
            amount={amount} 
            currency={currency} 
            referenceNumber={student.User_ID} // Pass reference number
          />
        </div>
      )}
    </div>
  );
};

export default StudentPayment;


// import React, { useState } from 'react';
// import CybersourceCheckout from './CybersourceCheckouts'; // Assuming it's in the same directory
// import './StudentNumberForm.css'; // Custom styles

// const mockDatabase = {
//   '123456': { firstName: 'John', lastName: 'Doe' },
//   '789012': { firstName: 'Jane', lastName: 'Smith' },
// };

// const StudentPayment = () => {
//   const [step, setStep] = useState(1);
//   const [studentNumber, setStudentNumber] = useState('');
//   const [student, setStudent] = useState(null);
//   const [amount, setAmount] = useState('');
//   const [currency, setCurrency] = useState('USD');

//   const handleLookup = () => {
//     const foundStudent = mockDatabase[studentNumber];
//     setStudent(foundStudent || null);
//     if (foundStudent) {
//       setStep(2); // Move to amount and currency step
//     } else {
//       alert('Student not found');
//     }
//   };

//   const handleProceed = () => {
//     if (student && amount) {
//       setStep(3); // Move to summary step
//     } else {
//       alert('Please fill in all fields');
//     }
//   };

//   return (
//     <div className="containerSec">
//       <h1>Unido Payment Portal</h1>
//       <h3>Accepting Payments via Visa</h3>

//       {step === 1 && (
//         <div className="lookup-form">
//           <input
//             type="text"
//             placeholder="Enter Student Number"
//             value={studentNumber}
//             onChange={(e) => setStudentNumber(e.target.value)}
//           />
//           <button onClick={handleLookup}>Lookup</button>
//         </div>
//       )}

//       {step === 2 && student && (
//         <div className="amount-currency-form">
//           <h2>Welcome, {student.firstName} {student.lastName}</h2>
//           <input
//             type="number"
//             placeholder="Enter Amount"
//             value={amount}
//             onChange={(e) => setAmount(e.target.value)}
//           />
//           <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
//             <option value="USD">USD</option>
//             <option value="ZMW">ZMW</option>
//           </select>
//           <button onClick={handleProceed}>Proceed to Summary</button>
//           <button onClick={() => setStep(1)}>Go Back</button>
//         </div>
//       )}
//       {step === 3 && (
//       <div className="summary-details">
//         <h2>Payment Summary</h2>
//         <p><strong>Student Number:</strong> {studentNumber}</p>
//         <p><strong>Name:</strong> {student.firstName} {student.lastName}</p>
//         <p><strong>Amount:</strong> {amount} {currency}</p>
//         <button onClick={() => setStep(2)}>Go Back</button>
//         <CybersourceCheckout 
//           student={student} 
//           amount={amount} 
//           currency={currency} 
//           referenceNumber={studentNumber} // Pass reference number
//         />
//       </div>
//     )}


//       {/* {step === 3 && (
//         <div className="summary-details">
//           <h2>Payment Summary</h2>
//           <p><strong>Student Number:</strong> {studentNumber}</p>
//           <p><strong>Name:</strong> {student.firstName} {student.lastName}</p>
//           <p><strong>Amount:</strong> {amount} {currency}</p>
//           <button onClick={() => setStep(2)}>Go Back</button>
//           <CybersourceCheckout student={student} amount={amount} currency={currency} />
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default StudentPayment;




// import React, { useState, useEffect } from "react";

// const CybersourceCheckout = () => {
//   const [formData, setFormData] = useState({
//     access_key: "e6417097589a39e68c60795bf48d543a",
//     profile_id: "CDBF4C39-0165-4E19-98AB-1D148E38A7AA",
//     transaction_uuid: generateUUID(),
//     currency: "USD",
//     locale: "en",
//     amount: "100.00",
//     signed_date_time: new Date().toISOString().replace(/\.\d+Z$/, 'Z'), // Adjust format
//     reference_number: "ada12345678wert936243swe12",
//     transaction_type: "sale",
//     bill_to_forename: "John",
//     bill_to_address_city: "Lusaka",
//     bill_to_address_country: "ZM",
//     bill_to_address_line1: "Not applicable",
//     bill_to_surname: "Doe",
//     bill_to_email: "johndoe@example.com",
//     signed_field_names:
//       "access_key,profile_id,transaction_uuid,currency,locale,amount,signed_date_time,transaction_type,reference_number,bill_to_forename,bill_to_address_line1,bill_to_address_city,bill_to_address_country,bill_to_surname,bill_to_email,signed_field_names,unsigned_field_names",
//     unsigned_field_names: "",
//     signature: ""
//   });

//   function generateUUID() {
//     return Math.random().toString(36).substring(2) + Date.now().toString(36);
//   }

//   useEffect(() => {
//     const fetchSignature = async () => {
//       try {
//         //const response = await fetch("http://localhost:5000/api/getSignature", {
//         const response = await fetch("https://app.unilus.ac.zm/api/getSignature", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(formData),
//         });
//         const data = await response.json();
//         if (data.signature) {
//           setFormData((prev) => ({ ...prev, signature: data.signature }));
//         } else {
//           console.error("Signature not returned from server:", data);
//         }
//       } catch (error) {
//         console.error("Error fetching signature:", error);
//       }
//     };

//     fetchSignature();
//   }, [formData.signed_date_time]); // Re-fetch signature when `signed_date_time` updates

//   return (
//     <form
//       method="POST"
//       action="https://testsecureacceptance.cybersource.com/pay"
//       id="cybersourceForm"
//     >
//       {Object.keys(formData).map((field) => (
//         <input key={field} type="hidden" name={field} value={formData[field]} />
//       ))}
//       <button type="submit">Pay Now</button>
//     </form>
//   );
// };

// export default CybersourceCheckout;

// import React, { useState, useEffect } from "react";

// const CybersourceCheckout = () => {
//   const [formData, setFormData] = useState({

//     //     access_key: "4e8523e0c7f83076b52cffcbbe39ecbf",
// //     profile_id: "40C5FB8D-5675-4BC7-AD56-2F63B394F7A4",
//     access_key: "e6417097589a39e68c60795bf48d543a",
//     profile_id: "CDBF4C39-0165-4E19-98AB-1D148E38A7AA",
//     transaction_uuid: generateUUID(),
//     currency: "USD",
//     locale: "en",
//     amount: "100.00",
//     //signed_date_time: new Date().toISOString(),
//     signed_date_time: new Date().toISOString(),
//     reference_number: "123456789",
//     //reference_number: "ORDER_1234554sdfsddsfgs",
//     transaction_type: "sale",
//     //transaction_type: "authorization,create_payment_token",
//     // payment_method: "card",

//     // Billing information (signed fields)
//     // bill_to_forename: "John",
//     // bill_to_surname: "Doe",
//     // bill_to_email: "johndoe@example.com",
//     // bill_to_phone: "1234567890",
//     // bill_to_address_line1: "123 Main St",
//     // bill_to_address_city: "San Francisco",
//     // bill_to_address_state: "CA",
//     // bill_to_address_country: "US",
//     // bill_to_address_postal_code: "94105",

//     // Card details (unsigned fields)
//     // card_type: "Visa", // Example card type
//     // card_number: "4111111111111111", // Example card number
//     // card_expiration: "12/25", // Example expiration
//     // card_security_code: "123", // Example CVV
//     signed_field_names:
//       "access_key,profile_id,transaction_uuid,currency,locale,amount,signed_date_time,transaction_type,reference_number,signed_field_names,unsigned_field_names",

//     // Signed and unsigned fields
//     // signed_field_names:
//     //   "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount",
//     // Signed and unsigned fields
//     // signed_field_names:
//     //   "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,payment_method,bill_to_forename,bill_to_surname,bill_to_email,bill_to_phone,bill_to_address_line1,bill_to_address_city,bill_to_address_state,bill_to_address_country,bill_to_address_postal_code",
//     unsigned_field_names: "",
//     //unsigned_field_names: "card_type,card_number,card_expiration",
//     signature: ""
//   });

//   function generateUUID() {
//     return Math.random().toString(36).substring(2) + Date.now().toString(36);
//   }

//   useEffect(() => {
//     const fetchSignature = async () => {
//       try {
//         const response = await fetch("http://localhost:5000/api/getSignature", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(formData),
//         });
//         const data = await response.json();

//         if (data.signature) {
//           setFormData((prev) => ({ ...prev, signature: data.signature }));
//         } else {
//           console.error("Signature not returned from server:", data);
//         }
//       } catch (error) {
//         console.error("Error fetching signature:", error);
//       }
//     };

//     fetchSignature();
//   }, [formData.signed_date_time]);

//   return (
//     <form
//       method="POST"
//       action="https://testsecureacceptance.cybersource.com/pay"
//       id="cybersourceForm"
//     >
//       {Object.keys(formData).map((field) => (
//         <input key={field} type="hidden" name={field} value={formData[field]} />
//       ))}
//       <button type="submit">Pay Now</button>
//     </form>
//   );
// };

// export default CybersourceCheckout;

// // App.js
// import React, { useState, useEffect } from "react";

// const CybersourceCheckout = () => {

//   // access_key: "9f81b411196b33d088e6b4f32ac948db", // Ensure this is set in your environment variables
//   //      profile_id: "66E280F9-C9F5-4850-B520-F1E17ECF7DBB",
//   const [formData, setFormData] = useState({
//     access_key: "4e8523e0c7f83076b52cffcbbe39ecbf",
//     profile_id: "40C5FB8D-5675-4BC7-AD56-2F63B394F7A4",
//     transaction_uuid: generateUUID(),
//     currency: "USD",
//     locale: "en",
//     amount: "100.00",
//     signed_date_time: new Date().toISOString(),
//     reference_number: "ORDER_12345",
//     transaction_type: "sale",
//     signed_fields_names: "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency",
//     signature: ""
//   });

//   function generateUUID() {
//     return Math.random().toString(36).substring(2) + Date.now().toString(36);
//   }

//   useEffect(() => {
//     fetch("http://localhost:5000/api/getSignature", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(formData)
//     })
//       .then((response) => response.json())
//       .then((data) => setFormData((prev) => ({ ...prev, signature: data.signature })))
//       .catch((error) => console.error("Error fetching signature:", error));
//   }, [formData.signed_date_time]);

//   return (
//     <form
//       method="POST"
//       action="https://testsecureacceptance.cybersource.com/pay"
//       id="cybersourceForm"
//     >
//       {Object.keys(formData).map((field) => (
//         <input key={field} type="hidden" name={field} value={formData[field]} />
//       ))}
//       <button type="submit">Pay Now</button>
//     </form>
//   );
// };

// export default CybersourceCheckout;

// // PaymentForm.js
// import React, { useState } from 'react';
// import axios from 'axios';

// const PaymentForm = () => {
//   const [paymentDetails, setPaymentDetails] = useState({
//     amount: '',
//     currency: 'USD',
//     transaction_type: 'sale',
//     reference_number: '',
//   });

//   const handleChange = (e) => {
//     setPaymentDetails({ ...paymentDetails, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post('http://localhost:5000/payment', paymentDetails);
//       // Redirect user to the Cybersource Hosted Checkout page
//       window.location.href = response.data.redirectUrl;
//     } catch (error) {
//       console.error('Payment initiation error:', error);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <div>
//         <label>Amount:</label>
//         <input
//           type="text"
//           name="amount"
//           value={paymentDetails.amount}
//           onChange={handleChange}
//         />
//       </div>
//       <div>
//         <label>Currency:</label>
//         <input
//           type="text"
//           name="currency"
//           value={paymentDetails.currency}
//           onChange={handleChange}
//         />
//       </div>
//       <div>
//         <label>Transaction Type:</label>
//         <input
//           type="text"
//           name="transaction_type"
//           value={paymentDetails.transaction_type}
//           onChange={handleChange}
//         />
//       </div>
//       <div>
//         <label>Reference Number:</label>
//         <input
//           type="text"
//           name="reference_number"
//           value={paymentDetails.reference_number}
//           onChange={handleChange}
//         />
//       </div>
//       <button type="submit">Submit Payment</button>
//     </form>
//   );
// };

// export default PaymentForm;

// import React, { useState } from 'react';

// const CheckoutForm = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     amount: '',
//     currency: 'USD',
//   });

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Send form data to the backend to generate signature
//     const response = await fetch('http://localhost:5000/generate-signature', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(formData),
//     });

//     const { access_key, profile_id, transaction_uuid, signed_date_time, amount, currency, locale, payment_method, reference_number, transaction_type, signed_field_names, signature } = await response.json();

//     // Prepare the form and redirect to Cybersource
//     const form = document.createElement('form');
//     form.action = 'https://testsecureacceptance.cybersource.com/silent/pay';
//     form.method = 'POST';

//     // Add required fields
//     const fields = {
//       access_key, profile_id, transaction_uuid, signed_date_time,
//       amount, currency, locale, payment_method, reference_number,
//       transaction_type, signed_field_names, signature,
//     };

//     // Append hidden inputs for each field
//     for (let key in fields) {
//       const input = document.createElement('input');
//       input.type = 'hidden';
//       input.name = key;
//       input.value = fields[key];
//       form.appendChild(input);
//     }

//     // Append the form to the body and submit it
//     document.body.appendChild(form);
//     form.submit();
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <label>First Name:</label>
//       <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />

//       <label>Last Name:</label>
//       <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />

//       <label>Email:</label>
//       <input type="email" name="email" value={formData.email} onChange={handleChange} required />

//       <label>Amount:</label>
//       <input type="text" name="amount" value={formData.amount} onChange={handleChange} required />

//       <button type="submit">Pay Now</button>
//     </form>
//   );
// };

// export default CheckoutForm;

// import React, { useState } from 'react';

// const CheckoutForm = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     amount: '',
//     currency: 'USD',
//   });

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // Submit form to backend to generate signed request
//     const response = await fetch('http://localhost:5000/generate-signature', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(formData),
//     });

//     const { signature, accessKey, profileId, signedDateTime } = await response.json();
    
//     // Redirect user to Cybersource hosted page with the signed form data
//     document.getElementById('cybersourceForm').submit();
//   };

//   return (
//     <form id="cybersourceForm" action="https://testsecureacceptance.cybersource.com/pay" method="post" onSubmit={handleSubmit}>
//     {/* <form id="cybersourceForm" action="https://secureacceptance.cybersource.com/pay" method="post" onSubmit={handleSubmit}> */}
//       {/* <input type="hidden" name="access_key" value="your-access-key" />
//       <input type="hidden" name="profile_id" value="your-profile-id" /> */}
//       <input type="hidden" name="access_key" value="4e8523e0c7f83076b52cffcbbe39ecbf" />
//       <input type="hidden" name="profile_id" value="40C5FB8D-5675-4BC7-AD56-2F63B394F7A4" />
//       <input type="hidden" name="transaction_uuid" value={Math.random().toString(36).substr(2, 9)} />
//       <input type="hidden" name="signed_field_names" value="access_key,profile_id,transaction_uuid,signed_date_time,amount,currency" />
//       <input type="hidden" name="unsigned_field_names" value="" />
//       <input type="hidden" name="signed_date_time" value="signedDateTime" />
//       <input type="hidden" name="signature" value="signature" />
      
//       {/* Customer and order details */}
//       <label>First Name:</label>
//       <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />

//       <label>Last Name:</label>
//       <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />

//       <label>Email:</label>
//       <input type="email" name="email" value={formData.email} onChange={handleChange} required />

//       <label>Amount:</label>
//       <input type="text" name="amount" value={formData.amount} onChange={handleChange} required />

//       <button type="submit">Pay Now</button>
//     </form>
//   );
// };

// export default CheckoutForm;



// import React, { useState } from 'react';
// import axios from 'axios';

// function App() {
//   const [amount, setAmount] = useState('');
//   const [message, setMessage] = useState('');

//   const handlePayment = async () => {
//     try {
//       const transaction_uuid = Math.random().toString(36).substring(2); // Generate a random UUID
//       const response = await axios.post('http://localhost:5000/api/payment', { 
//         amount,
//         transaction_uuid
//       });
//       setMessage('Payment processed successfully!');
//     } catch (error) {
//       setMessage('Payment failed');
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const amount = '100.00'; // Amount to charge
//     const currency = 'USD'; // Currency
//     const returnUrl = 'http://localhost:3000/thank-you'; // Your return URL
//     const profileId = 'YOUR_PROFILE_ID'; // Optional

//     try {
//         const response = await axios.post('http://localhost:5000/api/create-payment', {
//             amount,
//             currency,
//             returnUrl,
//             profileId,
//         });

//         // Render the payment form returned from the server
//         document.body.innerHTML = response.data; // Inject the form into the DOM
//     } catch (error) {
//         console.error('Error creating payment:', error);
//     }
// };


//   return (
//     <div style={{ padding: '20px' }}>
//       <h2>Cybersource Payment</h2>
//       <input
//         type="text"
//         placeholder="Enter amount"
//         value={amount}
//         onChange={(e) => setAmount(e.target.value)}
//         style={{ marginBottom: '10px' }}
//       />
//       <br />
//       <button onClick={handlePayment}>Pay Now</button>
//       <p>{message}</p>
//     </div>
//   );
// }

// export default App;

// // src/PaymentForm.js

// import React, { useState } from 'react';
// import CryptoJS from 'crypto-js'; // For HMAC signing

// const SECRET_KEY = '7ad7551852c04cb1ac8f0f9cfed89434d59337609d30426cb653a50ad53abf0260e099f424b14edfa4fcd0ba7925f5c563ce32133fb24e50b3859a963f1e47ff4eae4905e7a342e98836c498a6cfd2ef4d528af1c1f74ce686f0f79d7fe45a81882d5de507c84ce1bab40569fc570d6b18e26b6cc5f84f759909850aa3a099a7';

// const PaymentForm = () => {
//   const [formData, setFormData] = useState({
//     firstName: 'John',
//     lastName: 'Doe',
//     email: 'john.doe@example.com',
//     amount: '100',
//     currency: 'USD',
//     accessKey: '2e75260b74143647ba9db5f206844ffb', // Example access key
//     merchantId: 'm01400001', // Example merchant ID
//     profileId: 'DA760C19-FC4A-4239-ADE7-8333B085CF0E', // Example profile ID
//     transactionUUID: `uuid-${Date.now()}`, // Unique transaction UUID
//     signedFieldNames: 'amount,currency,firstName,lastName,email,accessKey,merchantId,profileId,transactionUUID',
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
  
//   //   const params = { ...formData };
//   //   const signature = sign(params);
  
//   //   const requestBody = {
//   //     ...params,
//   //     signature,
//   //   };
  
//   //   try {
//   //     const response = await fetch('http://localhost:5000/pay', {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/json',
//   //       },
//   //       body: JSON.stringify(requestBody),
//   //     });
  
//   //     if (!response.ok) {
//   //       throw new Error(`HTTP error! Status: ${response.status}`);
//   //     }
  
//   //     // Handle successful payment
//   //     const responseData = await response.json();
//   //     console.log('Payment successful:', responseData);
//   //   } catch (error) {
//   //     console.error('Error during payment:', error);
//   //   }
//   // };
  


//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
    
//   //   const params = { ...formData };
//   //   const signature = sign(params);
  
//   //   const requestBody = {
//   //     ...params,
//   //     signature,
//   //   };
  
//   //   try {
//   //     const response = await fetch('/pay', {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/json',
//   //       },
//   //       body: JSON.stringify(requestBody),
//   //     });
  
//   //     if (!response.ok) {
//   //       throw new Error(`HTTP error! Status: ${response.status}`);
//   //     }
  
//   //     // Handle successful payment
//   //     console.log('Payment successful');
//   //   } catch (error) {
//   //     console.error('Error during payment:', error);
//   //   }
//   // };
  
  
  

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const params = { ...formData };
//     const signature = sign(params);

//     const requestBody = {
//       ...params,
//       signature,
//     };

//     // Send the request to CyberSource
//     const response = await fetch('https://secureacceptance.cybersource.com/pay', {
//     //const response = await fetch('/pay', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(requestBody),
//     });

//     if (response?.ok) {
//       // Handle successful payment
//       console.log('Payment successful');
//     } else {
//       // Handle error
//       console.log('Payment failed');
//     }
//   };

//   const sign = (params) => {
//     const dataToSign = buildDataToSign(params);
//     return signData(dataToSign, SECRET_KEY);
//   };

//   const signData = (data, secretKey) => {
//     return CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(data, secretKey));
//   };

//   const buildDataToSign = (params) => {
//     const signedFieldNames = params.signedFieldNames.split(','); // Ensure it's defined
//     const dataToSign = signedFieldNames.map(field => `${field}=${params[field]}`);
//     return dataToSign.join(',');
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <h1>Payment Form</h1>
//       <label>
//         First Name:
//         <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
//       </label>
//       <label>
//         Last Name:
//         <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
//       </label>
//       <label>
//         Email:
//         <input type="email" name="email" value={formData.email} onChange={handleChange} />
//       </label>
//       <label>
//         Amount:
//         <input type="text" name="amount" value={formData.amount} onChange={handleChange} />
//       </label>
//       <label>
//         Currency:
//         <input type="text" name="currency" value={formData.currency} onChange={handleChange} />
//       </label>
      
//       {/* Hidden Fields */}
//       <input type="hidden" name="accessKey" value={formData.accessKey} />
//       <input type="hidden" name="merchantId" value={formData.merchantId} />
//       <input type="hidden" name="profileId" value={formData.profileId} />
//       <input type="hidden" name="transactionUUID" value={formData.transactionUUID} />
//       <input type="hidden" name="signed_field_names" value={formData.signedFieldNames} />
//       <input type="hidden" name="signature" value={sign(formData)} />

//       <button type="submit">Proceed to Checkout</button>
//     </form>
//   );
// };

// export default PaymentForm;


// // src/PaymentForm.js

// import React, { useState } from 'react';
// import CryptoJS from 'crypto-js'; // For HMAC signing

// const SECRET_KEY = '7ad7551852c04cb1ac8f0f9cfed89434d59337609d30426cb653a50ad53abf0260e099f424b14edfa4fcd0ba7925f5c563ce32133fb24e50b3859a963f1e47ff4eae4905e7a342e98836c498a6cfd2ef4d528af1c1f74ce686f0f79d7fe45a81882d5de507c84ce1bab40569fc570d6b18e26b6cc5f84f759909850aa3a099a7';

// const PaymentForm = () => {
//   const [formData, setFormData] = useState({
//     firstName: 'John',
//     lastName: 'Doe',
//     email: 'john.doe@example.com',
//     amount: '100',
//     currency: 'USD',
//     // Other necessary fields...
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const params = {
//       ...formData,
//       signed_field_names: 'amount,currency,firstName,lastName,email',
//     };

//     const signature = sign(params);

//     const requestBody = {
//       ...params,
//       signature,
//     };

//     // Send the request to CyberSource (use fetch or axios)
//     const response = await fetch('https://secureacceptance.cybersource.com/pay', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(requestBody),
//     });

//     if (response.ok) {
//       // Handle successful payment
//       console.log('Payment successful');
//     } else {
//       // Handle error
//       console.log('Payment failed');
//     }
//   };

//   const sign = (params) => {
//     const dataToSign = buildDataToSign(params);
//     return signData(dataToSign, SECRET_KEY);
//   };

//   const signData = (data, secretKey) => {
//     return CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(data, secretKey));
//   };

//   const buildDataToSign = (params) => {
//     const signedFieldNames = params.signed_field_names.split(',');
//     const dataToSign = signedFieldNames.map(field => `${field}=${params[field]}`);
//     return dataToSign.join(',');
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <h1>Payment Form</h1>
//       <label>
//         First Name:
//         <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
//       </label>
//       <label>
//         Last Name:
//         <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
//       </label>
//       <label>
//         Email:
//         <input type="email" name="email" value={formData.email} onChange={handleChange} />
//       </label>
//       <label>
//         Amount:
//         <input type="text" name="amount" value={formData.amount} onChange={handleChange} />
//       </label>
//       <label>
//         Currency:
//         <input type="text" name="currency" value={formData.currency} onChange={handleChange} />
//       </label>
//       <button type="submit">Proceed to Checkout</button>
//     </form>
//   );
// };

// export default PaymentForm;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import DeviceFingerprinting from '../DeviceFingerprinting/DeviceFingerprinting';

// const CybersourceForm = () => {
//   const [params, setParams] = useState({});
  
//   useEffect(() => {
//     // Fetch the necessary form data from your Node.js backend
//     axios.get('http://localhost:5000/api/cybersource-data')
//       .then(response => {
//         console.log("here",response)
//         setParams(response.data);
//       })
//       .catch(error => {
//         console.error('Error fetching Cybersource data:', error);
//       });
//   }, []);

//   const submitForm = () => {
//     // Submit the form by programmatically creating a form element and submitting it
//     const form = document.createElement('form');
//     form.method = 'POST';
//     form.action = 'https://secureacceptance.cybersource.com/pay';

//     // Add the hidden fields dynamically
//     Object.keys(params).forEach(key => {
//       const input = document.createElement('input');
//       input.type = 'hidden';
//       input.name = key;
//       input.value = params[key];
//       form.appendChild(input);
//     });

//     // Append the form to the body and submit
//     document.body.appendChild(form);
//     form.submit();
//   };

//   return (
//     <div>
//       <h2>Proceed to Payment</h2>
//       <button onClick={submitForm}>Submit Payment</button>
//          <DeviceFingerprinting df_org_id="k8vif92e" session_id={params.transaction_uuid} />

//     </div>
//   );
// };

// export default CybersourceForm;

// import { useState } from 'react';

// const CybersourceCheckout = () => {
//   const [formData, setFormData] = useState(null);

//   const getCheckoutData = async () => {
//     try {
//       // Fetch the form data from the backend
//       const response = await fetch('http://localhost:5000/api/cybersource/generate-checkout-data', {
//         method: 'POST',
//         body: JSON.stringify({
//           amount: '100.00',  // Example amount
//           currency: 'USD',  // Example currency
//         }),
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });

//       const data = await response.json();
//       setFormData(data);
//     } catch (error) {
//       console.error('Error fetching checkout data:', error);
//     }
//   };

//   const submitForm = () => {
//     document.getElementById('cybersource-form').submit();
//   };

//   return (
//     <div>
//       <button onClick={getCheckoutData}>Proceed to Payment</button>

//       {formData && (
//         <form
//           id="cybersource-form"
//           action="https://secureacceptance.cybersource.com/checkout"
//           method="POST"
//         >
//           <input type="hidden" name="access_key" value={formData.access_key} />
//           <input type="hidden" name="profile_id" value={formData.profile_id} />
//           <input type="hidden" name="transaction_uuid" value={formData.transaction_uuid} />
//           <input type="hidden" name="signed_field_names" value={formData.signed_field_names} />
//           <input type="hidden" name="unsigned_field_names" value={formData.unsigned_field_names} />
//           <input type="hidden" name="signature" value={formData.signature} />
//           <input type="hidden" name="amount" value={formData.amount} />
//           <input type="hidden" name="currency" value={formData.currency} />

//           {/* Additional fields as needed */}
          
//           <button type="button" onClick={submitForm}>Pay Now</button>
//         </form>
//       )}
//     </div>
//   );
// };

// export default CybersourceCheckout;





// import { useState } from 'react';

// const CybersourceCheckout = () => {
//   const [formData, setFormData] = useState(null);

//   //7ad7551852c04cb1ac8f0f9cfed89434d59337609d30426cb653a50ad53abf0260e099f424b14edfa4fcd0ba7925f5c563ce32133fb24e50b3859a963f1e47ff4eae4905e7a342e98836c498a6cfd2ef4d528af1c1f74ce686f0f79d7fe45a81882d5de507c84ce1bab40569fc570d6b18e26b6cc5f84f759909850aa3a099a7

//   const getCheckoutData = async () => {
//     // Simulating fetching from backend with dummy data
//     const dummyData = {
//       access_key: '2e75260b74143647ba9db5f206844ffb',
//       profile_id: 'DA760C19-FC4A-4239-ADE7-8333B085CF0E',  // Replace with your actual profile ID
//       transaction_uuid: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
//       signed_field_names: 'access_key,profile_id,transaction_uuid,amount,currency',
//       unsigned_field_names: '',
//       amount: '100.00',
//       currency: 'ZMW',
//       signature: 'DUMMYGENERATEDSIGNATURE',
//     };

//     setFormData(dummyData);
//   };

//   const submitForm = () => {
//     document.getElementById('cybersource-form').submit();
//   };

//   return (
//     <div>
//       <button onClick={getCheckoutData}>Proceed to Payment</button>

//       {formData && (
//         <form
//           id="cybersource-form"
//           action="https://secureacceptance.cybersource.com/pay"
//           //action="https://secureacceptance.cybersource.com/checkout"
//           method="POST"
//         >
//           <input type="hidden" name="access_key" value={formData.access_key} />
//           <input type="hidden" name="profile_id" value={formData.profile_id} />
//           <input type="hidden" name="transaction_uuid" value={formData.transaction_uuid} />
//           <input type="hidden" name="signed_field_names" value={formData.signed_field_names} />
//           <input type="hidden" name="unsigned_field_names" value={formData.unsigned_field_names} />
//           <input type="hidden" name="signature" value={formData.signature} />
//           <input type="hidden" name="amount" value={formData.amount} />
//           <input type="hidden" name="currency" value={formData.currency} />
//           <input type="hidden" id="bill_to_address_city" name="bill_to_address_city" value="Lusaka"/>
//           <input type="hidden" id="bill_to_address_country" name="bill_to_address_country" value="ZM"/>
//           <input type="hidden" id="bill_to_address_line1" name="bill_to_address_line1" value="Not applicable"/>
//           <input type="hidden" id="bill_to_email" name="bill_to_email" value="chrispine.kunda@gmail.com"/>
//           <input type="hidden" id="bill_to_forename" name="bill_to_forename" value="Paybills"/>
//           <input type="hidden" id="bill_to_surname" name="bill_to_surname" value="Customer"/>
//           {/* Add any other required fields here */}
//           <button type="button" onClick={submitForm}>Pay Now</button>
//         </form>
//       )}
//     </div>
//   );
// };

// export default CybersourceCheckout;

// import React, { useState } from 'react';
// import axios from 'axios';

// const PaymentForm = () => {
//   const [studentNumber, setStudentNumber] = useState('');
//   const [studentDetails, setStudentDetails] = useState(null);
//   const [amount, setAmount] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');

//   const handleFetchDetails = async () => {
//     try {
//       const { data } = await axios.get(`http://localhost:5000/api/payment/students/${studentNumber}`);
//       setStudentDetails(data);
//     } catch (error) {
//       setErrorMessage('Student not found.');
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!studentDetails) {
//       setErrorMessage('Please fetch student details first.');
//       return;
//     }

//     try {
//       const payload = {
//         studentNumber,
//         amount,
//         studentDetails, // Any other relevant details you'd need to pass to your backend
//       };

//       // Send data to the backend to create a signature and redirect
//       const { data } = await axios.post('http://localhost:5000/api/payment/payment/initiate', payload);

//       // Redirect to vendor payment page (Cybersource or any other)
//       window.location.href = data.redirectUrl;
//     } catch (error) {
//       setErrorMessage('Error initiating payment.');
//     }
//   };

//   return (
//     <div>
//       <h2>Enter Student Information</h2>
//       <form onSubmit={handleSubmit}>
//         <div>
//           <label>Student Number</label>
//           <input 
//             type="text"
//             value={studentNumber}
//             onChange={(e) => setStudentNumber(e.target.value)}
//           />
//           <button type="button" onClick={handleFetchDetails}>Fetch Details</button>
//         </div>

//         {studentDetails && (
//           <div>
//             <h3>Student Details</h3>
//             <p>Name: {studentDetails.name}</p>
//             <p>Email: {studentDetails.email}</p>
//             {/* Add any other relevant details */}
//           </div>
//         )}

//         {studentDetails && (
//           <div>
//             <label>Enter Amount</label>
//             <input 
//               type="number"
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//             />
//           </div>
//         )}

//         {studentDetails && (
//           <button type="submit">Proceed to Payment</button>
//         )}

//         {errorMessage && <p>{errorMessage}</p>}
//       </form>
      
//     </div>
//   );
// };

// export default PaymentForm;

// // frontend/src/components/StudentNumberForm.js

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import './StudentNumberForm.css'; // Create and import CSS as needed

// const StudentNumberForm = () => {
//   const navigate = useNavigate();
//   const [studentNumber, setStudentNumber] = useState('');
//   const [error, setError] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!studentNumber.trim()) {
//       setError('Please enter a valid student number.');
//       return;
//     }

//     try {
//       // Optionally, validate student number format here

//       // Navigate to StudentDetails page with student number as state
//       navigate('/details', { state: { studentNumber } });
//     } catch (err) {
//       console.error('Error:', err);
//       setError('An unexpected error occurred.');
//     }
//   };

//   return (
//     <div className="form-container">
//       <h2>Enter Student Number</h2>
//       <form onSubmit={handleSubmit}>
//         <div className="input-block">
//           <label htmlFor="studentNumber">Student Number:</label>
//           <input
//             type="text"
//             id="studentNumber"
//             name="studentNumber"
//             value={studentNumber}
//             onChange={(e) => setStudentNumber(e.target.value)}
//             required
//           />
//         </div>
//         {error && <p className="error">{error}</p>}
//         <button type="submit" className="button">Next</button>
//       </form>
//     </div>
//   );
// };

// export default StudentNumberForm;
